





























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IChatRoomItem, IDetail } from "@/api/types";
import Barrage from "@/components/barrage/Index.vue";
import { IBarrageItem } from "@/components/barrage/type";

@Component({
  components: {
    Barrage
  }
})
export default class VideoBox extends Vue {
  @Prop()
  detail!: IDetail;
  @Prop()
  liveMute!: number | null;
  @Prop()
  barrageList!: IChatRoomItem[];
  @Prop()
  showBarrage!: boolean;
  @Prop()
  showBarrageName!: boolean;
  /**
   * 背景音乐列表
   */
  @Prop({ required: true })
  bgAudioList!: { url: string; ids: number[] }[];
  /**
   * 是否播放bg音乐
   */
  @Prop({ default: true })
  switch!: boolean;
  currentVideoIndex = 0;
  currentDate = new Date().getTime();
  /**
   * 视频是否正在播放
   */
  videoIsPlay = false;
  mounted() {
    this.bindEvent();
    this.IsAudio(0);
  }

  get showBarrageList(): IBarrageItem[] {
    if (this.barrageList) {
      return this.barrageList.map(item => {
        return {
          content: this.showBarrageName
            ? this.isAnonymaous(item) + " : " + item.content
            : item.content
        };
      });
    }
    return [];
  }

  get showOnlineTime(): boolean {
    const onlineTime = new Date(this.detail.onlineTime.replace(/-/g, "/")); // 传入直播开始时间
    const nowTime = new Date(); // 获取当前时间
    const timeDifference = onlineTime.getTime() - nowTime.getTime(); // 时间差的毫秒数
    if (timeDifference <= 0) {
      return false;
    }
    return true;
  }

  isAnonymaous(data: IChatRoomItem) {
    if (data.type === 0) {
      return data.name;
    } else if (data.type === 1) {
      return data.anonymousName;
    }
  }

  @Watch("switch")
  switchChange(newSwitch: boolean) {
    const id = (this.$refs.videoRef as HTMLAudioElement).dataset.id;
    if (!id) return;
    if (newSwitch) {
      this.videoIsPlay ? this.audioContorl(+id, "play") : "";
    } else {
      this.audioContorl(+id, "pause");
    }
  }

  /**
   * 选择镜头
   */
  selectTab(index: number) {
    const videoEle = this.$refs.videoRef as HTMLAudioElement;
    videoEle.pause();
    setTimeout(() => {
      this.currentVideoIndex = index;
      this.IsAudio(index);
    }, 100);
  }
  /**
   * 是否显示audio标签
   */
  IsAudio(index: number) {
    let isAudio = false;
    if (this.detail.cameraLensList!.length > 0) {
      isAudio = this.detail.cameraLensList![index].audioUrl ? true : false;
    }
    // 当前镜头是否有音频
    this.$emit("update:isAudio", isAudio);
  }
  /**
   * 绑定事件
   */
  bindEvent() {
    const videoEle = this.$refs.videoRef as HTMLAudioElement;
    if (!videoEle) return;
    /**
     * 微信中自动播放视频
     */
    document.addEventListener(
      "WeixinJSBridgeReady",
      () => {
        videoEle.play();
        const id = videoEle.dataset.id;
        if (!id) return;
        this.audioContorl(+id, "play");
      },
      false
    );
    /**
     * 监听视频播放事件
     */
    videoEle.addEventListener("play", (e: Event) => {
      const ele = e.target as HTMLVideoElement;
      ele.muted = Boolean(this.liveMute);
      this.videoIsPlay = true;
      const id = ele.dataset.id;
      if (!id) return;
      // this.audioContorl(+id, "play");
    });
    /**
     * 监听视频暂停事件
     */
    videoEle.addEventListener("pause", (e: Event) => {
      const ele = e.target as HTMLVideoElement;
      const id = ele.dataset.id;
      this.videoIsPlay = false;
      if (!id) return;
      this.audioContorl(+id, "pause");
    });
  }
  /**
   * 音频控制器
   */
  audioContorl(id: number, type: "play" | "pause") {
    // console.log("audioContorl", type);
    // console.log("switch", this.switch);
    this.pauseAllAudio();
    const index = this.bgAudioList.findIndex(item => item.ids.includes(id));
    if (index == -1) return;
    if (type == "play") {
      if (!this.switch) return;
      (this.$refs.bgAudio as HTMLAudioElement[])[index].play();
    } else {
      this.pauseAllAudio();
    }
  }

  /**
   * 暂停所有音频
   */
  pauseAllAudio() {
    const audioList = this.$refs.bgAudio as HTMLAudioElement[];
    console.log(audioList);
    if (audioList.length <= 0) return;
    audioList.forEach(audioEle => {
      audioEle.pause();
    });
  }

  removeList(length: number) {
    this.$emit("removeList", length);
  }
}
